import React from 'react';
import '../../../CSS/UI Components/NewServiceCardInStore_Mobile.css';
import clockIcon from '../../../Assets/clockIcon.png'
import moment from 'moment'
import momenttz from "moment-timezone"
const NewServiceCardInStore = ({
  state,
  categoryName,
  proData,
  clickOnAtHome,
  onPressCard,
  serviceCount,
  fromServiceSearch,
  servicePriceCurrency,
  proArray,
  isLast,
  serviceData
}) => {
//   let rating =
//     clickOnAtHome || proData.MERCHANT_PERSONNEL_STORE_TYPE === 'virtual'
//       ? proData.MERCHANT_PERSONNEL_ATHOME_RATING
//         ? Number(proData.MERCHANT_PERSONNEL_ATHOME_RATING).toFixed(1)
//         : ''
//       : proData.MERCHANT_PERSONNEL_RATING
//       ? Number(proData.MERCHANT_PERSONNEL_RATING).toFixed(1)
//       : '';
  return (
    <div className="npc-card" onClick={onPressCard} style={{ cursor: 'pointer' }}>
      <div style={{ position: 'relative' }}>
        <img
        //   src={proData.PROFESSIONAL_IMAGE || proData.image_link}
          src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753780019158-lg.webp'}
        //   alt={proData.MERCHANT_NAME}
          className="npc-card-image"
        />
        {/* <div className="npc-rating-tag">
          <span className="npc-rating-text">
            {"4.5"} <span style={{ color: '#92c63d', fontSize: 14 }}>★</span>
          </span>
        </div> */}
      </div>
      <div className="npc-service-details">
        <div className="npc-card-title">
          {/* {proData.MERCHANT_NAME} */}
          {serviceData.SERVICE_NAME}
        </div>
        {/* {!(clickOnAtHome || proData.MERCHANT_PERSONNEL_STORE_TYPE === 'virtual') && ( */}
          <div className="npc-location-row">
            {/* <text style={[styles.slashedPriceStyle, { marginRight: 8 }]}>{(data.SERVICE_CURRENCY === "Rupees" ? '\u20B9' : "$") + data.service_list_price}</text>
            <text style={[styles.priceStyle, { marginRight: 3,color:data.serviceCard ? (data.serviceCard == 1 ? "#f69708" : (data.serviceCard == 2 ? "#007bd5" : (data.serviceCard == 3 ? "#db2bc9" : "#2d2d2d"))) : "#2d2d2d"}]}>{(data.SERVICE_CURRENCY === "Rupees" ? '\u20B9' : "$") + data.service_offer_price}</text> */}
            <text className='listPriceStyle'>{( '\u20B9') + serviceData.service_list_price}</text>
            <text className='offerPriceStyle'>{('\u20B9') + serviceData.service_offer_price}</text>
            <div className='discountContainer'>
                <text className='discountStyle'>{serviceData.service_discount}{" %"}</text>
            </div>
          </div>
        {/* )}  */}
        <div className="npc-line-style" />
        <div className='durationDivStyle'>
            <img src={clockIcon} style={{ width: 15, height: 15 }} />
            <text className='durationStyle'>{moment.utc(moment.duration(serviceData.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("H") == 0 ? null : moment.utc(moment.duration(serviceData.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("H") + "h"}{' '}{moment.utc(moment.duration(serviceData.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("mm") == 0 ? null : moment.utc(moment.duration(serviceData.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("mm") + "m"}</text>
        </div>
      </div>
      {/* Add discount or other tags as needed */}
    </div>
  );
};

export default NewServiceCardInStore;